<template>
  <v-form ref="form" v-model="valid">
    <!-- Header chuẩn Mẫu số 05 - VT -->
    <v-card outlined class="pa-4 mb-3 grey lighten-5">
      <div class="d-flex justify-space-between align-start mb-2">
        <div>
          <div class="text-caption grey--text text--darken-1 font-weight-bold">ĐƠN VỊ: TRƯỜNG HỌC / TRUNG TÂM</div>
          <div class="text-caption grey--text text--darken-1">BỘ PHẬN: QUẢN LÝ CƠ SỞ VẬT CHẤT & THIẾT BỊ</div>
        </div>
        <div class="text-right">
          <div class="text-caption font-weight-bold">Mẫu số 05 - VT</div>
          <div class="text-caption grey--text">(Ban hành theo TT số 133/2014/TT-BTC & 200/2014/TT-BTC)</div>
        </div>
      </div>
      <div class="text-center my-2">
        <h3 class="primary--text font-weight-bold text-uppercase">
          BIÊN BẢN KIỂM KÊ VẬT TƯ, CÔNG CỤ, SẢN PHẨM, HÀNG HOÁ, TÀI SẢN
        </h3>
      </div>
    </v-card>

    <v-row dense>
      <!-- Hàng 1: Mã, Tiêu đề, Ngày & Giờ kiểm kê -->
      <v-col cols="12" md="3">
        <v-text-field
          v-model="formData.code"
          placeholder="Tự động sinh (VD: KK_2026_001)"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng nhập mã đợt kiểm kê']"
        >
          <template v-slot:label>
            Mã đợt kiểm kê <span class="red--text font-weight-bold">*</span>
          </template>
          <template v-slot:append>
            <v-btn x-small text color="primary" @click="generateAutoCode" title="Tự sinh mã mới">Tự sinh</v-btn>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
          v-model="formData.title"
          placeholder="VD: Biên bản kiểm kê tài sản thiết bị cuối học kỳ..."
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng nhập tên đợt kiểm kê']"
        >
          <template v-slot:label>
            Tên đợt kiểm kê / Tiêu đề biên bản <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="formData.auditDate"
          type="date"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng chọn ngày']"
        >
          <template v-slot:label>
            Ngày kiểm kê <span class="red--text font-weight-bold">*</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="formData.auditTime"
          type="time"
          label="Giờ kiểm kê"
          outlined
          dense
        />
      </v-col>

      <!-- Hàng 2: Ban kiểm kê (Trưởng ban, Kế toán trưởng, Thủ kho, Trạng thái) -->
      <v-col cols="12" md="3">
        <v-combobox
          v-model="formData.auditor"
          :items="users"
          :loading="loadingUsers"
          item-text="fullName"
          item-value="fullName"
          :return-object="false"
          placeholder="Chọn hoặc nhập họ tên..."
          outlined
          dense
          clearable
          :rules="[v => !!v || 'Vui lòng nhập/chọn Trưởng ban kiểm kê']"
        >
          <template v-slot:label>
            Trưởng ban kiểm kê <span class="red--text font-weight-bold">*</span>
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex justify-space-between align-center w-100 py-1" style="min-width: 260px;">
              <div class="d-flex align-center mr-4 text-truncate">
                <v-avatar rounded size="24" class="mr-2 flex-shrink-0">
                  <v-img :src="item.avatar || '/default-avatar.svg'" />
                </v-avatar>
                <span class="font-weight-medium text-truncate">{{ item.fullName }}</span>
              </div>
              <v-chip v-if="item.code || item.role" x-small outlined color="primary" class="ml-auto flex-shrink-0">
                {{ item.code || item.role }}
              </v-chip>
            </div>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="12" md="3">
        <v-combobox
          v-model="formData.approver"
          :items="users"
          :loading="loadingUsers"
          item-text="fullName"
          item-value="fullName"
          :return-object="false"
          placeholder="Chọn hoặc nhập họ tên..."
          outlined
          dense
          clearable
          :rules="[v => !!v || 'Vui lòng nhập/chọn Kế toán trưởng / Người duyệt']"
        >
          <template v-slot:label>
            Kế toán trưởng / Người duyệt <span class="red--text font-weight-bold">*</span>
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex justify-space-between align-center w-100 py-1" style="min-width: 260px;">
              <div class="d-flex align-center mr-4 text-truncate">
                <v-avatar rounded size="24" class="mr-2 flex-shrink-0">
                  <v-img :src="item.avatar || '/default-avatar.svg'" />
                </v-avatar>
                <span class="font-weight-medium text-truncate">{{ item.fullName }}</span>
              </div>
              <v-chip v-if="item.code || item.role" x-small outlined color="teal" class="ml-auto flex-shrink-0">
                {{ item.code || item.role }}
              </v-chip>
            </div>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="12" md="3">
        <v-combobox
          v-model="formData.manager"
          :items="users"
          :loading="loadingUsers"
          item-text="fullName"
          item-value="fullName"
          :return-object="false"
          placeholder="Chọn hoặc nhập họ tên..."
          outlined
          dense
          clearable
          :rules="[v => !!v || 'Vui lòng nhập/chọn Thủ kho / Người quản lý']"
        >
          <template v-slot:label>
            Thủ kho / Người quản lý <span class="red--text font-weight-bold">*</span>
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex justify-space-between align-center w-100 py-1" style="min-width: 260px;">
              <div class="d-flex align-center mr-4 text-truncate">
                <v-avatar rounded size="24" class="mr-2 flex-shrink-0">
                  <v-img :src="item.avatar || '/default-avatar.svg'" />
                </v-avatar>
                <span class="font-weight-medium text-truncate">{{ item.fullName }}</span>
              </div>
              <v-chip v-if="item.code || item.role" x-small outlined color="deep-orange" class="ml-auto flex-shrink-0">
                {{ item.code || item.role }}
              </v-chip>
            </div>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="formData.status"
          :items="statusList"
          outlined
          dense
          :rules="[v => !!v || 'Vui lòng chọn trạng thái']"
        >
          <template v-slot:label>
            Trạng thái <span class="red--text font-weight-bold">*</span>
          </template>
        </v-select>
      </v-col>

      <!-- Bảng kiểm kê chi tiết Mẫu 05 - VT -->
      <v-col cols="12">
        <AuditFormItems
          ref="auditFormItems"
          :items="formData.items"
          :categories="categories"
          :all-assets="allAssets"
          :locations="locations"
          :loading-categories="loadingCategories"
          :loading-assets="loadingAssets"
        />
      </v-col>

      <!-- Ý kiến giải quyết số chênh lệch / Kết luận -->
      <v-col cols="12">
        <v-textarea
          v-model="formData.conclusion"
          label="Ý kiến giải quyết số chênh lệch / Kết luận của Ban kiểm kê"
          outlined
          dense
          rows="2"
          placeholder="Ý kiến xử lý tài sản thừa, thiếu, đề xuất sửa chữa, bảo dưỡng hoặc thanh lý..."
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { AssetCategory, Asset, FacilityLocation, User, Staff, Teacher, AssetInventoryAudit } from '@/plugins/api'
import { get } from 'lodash'
import AuditFormItems from './AuditFormItems.vue'

export default {
  name: 'AuditForm',
  components: {
    AuditFormItems
  },
  data() {
    return {
      valid: true,
      loadingCategories: false,
      loadingAssets: false,
      loadingLocations: false,
      loadingUsers: false,
      categories: [],
      allAssets: [],
      locations: [],
      users: [],
      statusList: [
        { text: 'Bản nháp', value: 'DRAFT' },
        { text: 'Đang kiểm kê', value: 'IN_PROGRESS' },
        { text: 'Đã hoàn thành', value: 'COMPLETED' }
      ],
      formData: {
        code: '',
        title: '',
        auditDate: new Date().toISOString().substring(0, 10),
        auditTime: '08:00',
        auditor: '',
        approver: '',
        manager: '',
        status: 'IN_PROGRESS',
        conclusion: '',
        items: []
      }
    }
  },
  created() {
    if (!this.formData.items.length) {
      this.formData.items.push({
        category: null,
        categoryCode: '',
        categoryName: '',
        assetCode: '',
        assetName: '',
        unit: '',
        price: 0,
        systemQuantity: 0,
        systemAmount: 0,
        actualQuantity: 0,
        actualAmount: 0,
        diffSurplusQty: 0,
        diffSurplusAmount: 0,
        diffDeficitQty: 0,
        diffDeficitAmount: 0,
        diff: 0,
        qtyGood: 0,
        qtyDegraded: 0,
        qtyBad: 0,
        action: 'Không xử lý',
        note: '',
        subAssets: []
      })
    }
    this.generateAutoCode()
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loadingCategories = true
      AssetCategory.search({ _limit: -1, isDelete: false })
        .then(cats => {
          this.categories = cats || []
        })
        .catch(e => console.error('Error loading categories:', e))
        .finally(() => {
          this.loadingCategories = false
        })

      this.loadingAssets = true
      Asset.search({ _limit: -1, isDelete: false })
        .then(assets => {
          this.allAssets = assets || []
        })
        .catch(e => console.error('Error loading assets:', e))
        .finally(() => {
          this.loadingAssets = false
        })

      this.loadingLocations = true
      FacilityLocation.search({ _limit: -1, isDelete: false })
        .then(locs => {
          this.locations = locs || []
        })
        .catch(e => console.error('Error loading locations:', e))
        .finally(() => {
          this.loadingLocations = false
        })

      this.loadingUsers = true
      Promise.allSettled([
        Staff.search({ _limit: -1 }),
        Teacher.search({ _limit: -1 }),
        User.search({ _limit: 200 })
      ])
        .then(([staffRes, teacherRes, usersRes]) => {
          const userMap = new Map()

          if (staffRes.status === 'fulfilled' && Array.isArray(staffRes.value)) {
            staffRes.value.forEach(s => {
              const fullName = s.name && s.name.trim()
              if (fullName && !userMap.has(fullName)) {
                userMap.set(fullName, {
                  id: s.id,
                  fullName: fullName,
                  code: s.code || '',
                  avatar: get(s, 'avatar.url', (typeof s.avatar === 'string' ? s.avatar : '/default-avatar.svg')),
                  role: 'Nhân viên'
                })
              }
            })
          }

          if (teacherRes.status === 'fulfilled' && Array.isArray(teacherRes.value)) {
            teacherRes.value.forEach(t => {
              const fullName = t.name && t.name.trim()
              if (fullName && !userMap.has(fullName)) {
                userMap.set(fullName, {
                  id: t.id,
                  fullName: fullName,
                  code: t.code || '',
                  avatar: get(t, 'avatar.url', (typeof t.avatar === 'string' ? t.avatar : '/default-avatar.svg')),
                  role: 'Giáo viên'
                })
              }
            })
          }

          if (usersRes.status === 'fulfilled' && Array.isArray(usersRes.value)) {
            usersRes.value.forEach(u => {
              const fullName = u.fullName && u.fullName.trim()
              if (fullName && fullName !== u.username && !userMap.has(fullName)) {
                userMap.set(fullName, {
                  id: u.id,
                  fullName: fullName,
                  code: '',
                  avatar: get(u, 'avatar.url', (typeof u.avatar === 'string' ? u.avatar : '/default-avatar.svg')),
                  role: 'Người dùng'
                })
              }
            })
          }

          this.users = Array.from(userMap.values()).sort((a, b) =>
            a.fullName.localeCompare(b.fullName, 'vi')
          )
        })
        .catch(e => {
          console.error('Error loading users:', e)
        })
        .finally(() => {
          this.loadingUsers = false
        })
    },
    validate() {
      const isFormValid = this.$refs.form.validate()
      if (!isFormValid) return false

      if (this.$refs.auditFormItems && typeof this.$refs.auditFormItems.validate === 'function') {
        const isItemsValid = this.$refs.auditFormItems.validate()
        if (!isItemsValid) return false
      }

      return true
    },
    getData() {
      const catNames = new Set()
      let totalSystem = 0
      let totalActual = 0
      let totalDiff = 0
      let totalSystemAmount = 0
      let totalActualAmount = 0

      if (Array.isArray(this.formData.items)) {
        this.formData.items.forEach(it => {
          if (it.categoryName && it.categoryName !== '-' && it.categoryName.trim()) {
            catNames.add(it.categoryName.trim())
          }
          totalSystem += Number(it.systemQuantity) || 0
          totalActual += Number(it.actualQuantity) || 0
          totalDiff += Number(it.diff) || 0
          totalSystemAmount += Number(it.systemAmount) || 0
          totalActualAmount += Number(it.actualAmount) || 0
        })
      }

      return {
        ...this.formData,
        totalSystem,
        totalActual,
        totalDiff,
        totalSystemAmount,
        totalActualAmount,
        scope: Array.from(catNames)
      }
    },
    resetValidation() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
    async generateAutoCode() {
      try {
        const res = await AssetInventoryAudit.generateCode()
        if (res && res.code) {
          this.formData.code = res.code
          return
        }
      } catch (e) {
        console.warn('Fallback to local auto code generation:', e)
      }

      try {
        const year = new Date().getFullYear()
        const latestList = await AssetInventoryAudit.search({
          _limit: 20,
          _sort: 'createdAt:DESC',
          isDelete: false
        })
        let maxNum = 0
        if (Array.isArray(latestList)) {
          latestList.forEach(a => {
            if (a.code) {
              const match = a.code.match(/KK[_-]?\d{4}[_-]?(\d+)/i) || a.code.match(/(\d+)$/)
              if (match && match[1]) {
                const n = parseInt(match[1], 10)
                if (!isNaN(n) && n > maxNum) maxNum = n
              }
            }
          })
        }
        if (maxNum === 0) {
          const count = await AssetInventoryAudit.count({ isDelete: false })
          maxNum = count || 0
        }
        this.formData.code = `KK_${year}_${String(maxNum + 1).padStart(3, '0')}`
      } catch (e) {
        const year = new Date().getFullYear()
        const count = Math.floor(1 + Math.random() * 99)
        this.formData.code = `KK_${year}_${String(count).padStart(3, '0')}`
      }
    },
    initForm() {
      this.formData = {
        code: '',
        title: '',
        auditDate: new Date().toISOString().substring(0, 10),
        auditTime: '08:00',
        auditor: '',
        approver: '',
        manager: '',
        status: 'IN_PROGRESS',
        conclusion: '',
        items: [
          {
            category: null,
            categoryCode: '',
            categoryName: '',
            assetCode: '',
            assetName: '',
            unit: '',
            price: 0,
            systemQuantity: 0,
            systemAmount: 0,
            actualQuantity: 0,
            actualAmount: 0,
            diffSurplusQty: 0,
            diffSurplusAmount: 0,
            diffDeficitQty: 0,
            diffDeficitAmount: 0,
            diff: 0,
            qtyGood: 0,
            qtyDegraded: 0,
            qtyBad: 0,
            action: 'Không xử lý',
            note: '',
            subAssets: []
          }
        ]
      }
      this.generateAutoCode()
      this.fetchData()
      if (this.$refs.form) this.$refs.form.resetValidation()
    }
  }
}
</script>
